import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { soccerPath } from '../utils/paths';
import './PortalClubsSection.css';

const PortalClubsSection = () => {
  const [clubs, setClubs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadClubs = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const data = await api.getApprovedClubs();
      setClubs(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.message || 'Failed to load clubs');
      setClubs([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadClubs();
  }, [loadClubs]);

  return (
    <section className="portal-clubs" aria-label="Registered clubs">
      <div className="portal-clubs__header">
        <h2>Registered clubs</h2>
        <Link to={soccerPath('/clubs/list')} className="portal-clubs__view-all">
          View all →
        </Link>
      </div>

      {loading && <p className="portal-clubs__status">Loading clubs…</p>}

      {error && !loading && (
        <p className="portal-clubs__status portal-clubs__status--error">{error}</p>
      )}

      {!loading && !error && clubs.length === 0 && (
        <p className="portal-clubs__status">No clubs registered yet.</p>
      )}

      {!loading && !error && clubs.length > 0 && (
        <ul className="portal-clubs__grid">
          {clubs.map((club) => (
            <li key={club.id}>
              <Link to={soccerPath(`/clubs/${club.id}`)} className="portal-clubs__card">
                {club.logoUrl ? (
                  <img src={club.logoUrl} alt="" className="portal-clubs__logo" loading="lazy" />
                ) : (
                  <span className="portal-clubs__logo-placeholder" aria-hidden="true">
                    ⚽
                  </span>
                )}
                <div className="portal-clubs__info">
                  <h3>{club.name}</h3>
                  {club.description && (
                    <p>
                      {club.description.length > 120
                        ? `${club.description.slice(0, 120)}…`
                        : club.description}
                    </p>
                  )}
                </div>
                <span className="portal-clubs__link-label">Open club →</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};

export default PortalClubsSection;
